export const UK_DRIVING_LICENCE_REGEX = /^[A-Z9]{5}\d{6}[A-Z9]{2}\d[A-Z]{2}$/;

export const UK_PHONE_REGEX = /^(?:44|0)7\d{9}$/;
// export const UK_PHONE_REGEX = /^(?:\+44|0)7\d{9}$/;
